import React from 'react'
import { DatePicker } from '@material-ui/pickers'
import Typography from '@material-ui/core/Typography'
import { Controller, useFormContext } from 'react-hook-form'
import moment from 'moment'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'
import { map } from 'lodash'
import { Box, Grid } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

const timeValues = [
  {
    value: '9:00',
    label: '9:00 - 11:00'
  },
  {
    value: '11:00',
    label: '11:00 - 13:00'
  },
  {
    value: '13:00',
    label: '13:00 - 15:00'
  },
  {
    value: '15:00',
    label: '15:00 - 17:00'
  },
  {
    value: '17:00',
    label: '17:00 - 19:00'
  },
]

function disableWeekends(date) {
  return date.weekday() === 0 || date.weekday() === 6
}

const VisitDate = (props) => {
  const { t } = useTranslation()
  const { control, errors, watch } = useFormContext()
  const values = watch()
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid item xs={12}>
        <Box marginBottom={3}>
          <Typography variant='h4'>{t('visit.first.title')}</Typography>
        </Box>
      </Grid>
      <Grid item xs={12} lg={10}>
        <Box marginBottom={1}>
          <Typography variant='h6'>{t('visit.first.label')}</Typography>
        </Box>
      </Grid>
      <Grid item xs={12} lg={10}>
        <Controller
          name='date'
          control={control}
          defaultValue={null}
          as={<DatePicker
            inputVariant='outlined'
            fullWidth
            error={errors.date}
            format='DD-MM-yyyy'
            shouldDisableDate={disableWeekends}
            minDate={moment().add('days', 1)}
            label={t('visit.first.form.placeholders.date')}
            name='date'
          />}
        />
      </Grid>
      <Grid item xs={12} lg={10}>
        <Controller
          name='time'
          control={control}
          defaultValue={values.time}
          render={props => (
            <FormControl fullWidth variant='outlined' error={errors.time}>
              <InputLabel>{t('visit.first.form.placeholders.time')}</InputLabel>
              <Select
                value={values.time}
                onChange={props.onChange}
                name='time'
                label={t('visit.first.form.placeholders.time')}
              >
                {map(timeValues, time => <MenuItem value={time.value}>{time.label}</MenuItem>)}
              </Select>
            </FormControl>
          )}
        />
      </Grid>
    </Grid>
  )
}

export default VisitDate